import type { AutoWithdrawalDto } from '@shared/api/contracts';
import type { AutoWithdrawalSettingsStatus } from '../model/auto-withdrawal';

export const getAutoWithdrawalSettingsStatus = (
  settings: AutoWithdrawalDto | null | undefined,
): AutoWithdrawalSettingsStatus => {
  if (!settings) return 'none';

  const rules = settings.rules ?? [];
  const enabledRules = rules.filter((rule) => rule.enabled);
  if (enabledRules.length === 0) return 'none';

  const verifiedCount = enabledRules.filter((rule) => rule.hasVerification).length;

  if (verifiedCount === 0) return 'pending';
  if (verifiedCount === enabledRules.length) return 'active';
  return 'partial';
};
